// PGCET MCA Mock 2 — General English (questions 91–100)
const pgcetmcaGeneralEnglish = [
  {
    id: 91,
    question: "Choose the word nearest in meaning to OBFUSCATE.",
    options: ["A. Clarify", "B. Reveal", "C. Obscure", "D. Simplify"],
    answer: "C"
  },
  {
    id: 92,
    question: "Choose the antonym of EPHEMERAL.",
    options: ["A. Enduring", "B. Transient", "C. Fleeting", "D. Brief"],
    answer: "A"
  },
  {
    id: 93,
    question: "Choose the correct meaning of the idiom \"to throw in the towel\".",
    options: ["A. To clean up after a task", "B. To admit defeat and give up", "C. To start a fight", "D. To celebrate a victory"],
    answer: "B"
  },
  {
    id: 94,
    question: "Choose the one word for: a person who endures pain or hardship without showing feelings or complaining.",
    options: ["A. Hedonist", "B. Cynic", "C. Ascetic", "D. Stoic"],
    answer: "D"
  },
  {
    id: 95,
    question: "Choose the correct word to fill the blank: Neither the manager nor the employees ______ aware of the change in policy.",
    options: ["A. was", "B. is", "C. were", "D. has been"],
    answer: "C"
  },
  {
    id: 96,
    question: "Choose the correct indirect form of: He said, \"I have finished my work.\"",
    options: [
      "A. He said that he has finished his work.",
      "B. He said that he had finished his work.",
      "C. He said that I had finished my work.",
      "D. He said that he finished my work."
    ],
    answer: "B"
  },
  {
    id: 97,
    question: "Find the part of the sentence that contains an error: Each of the students (A) / have submitted (B) / the assignment on time (C) / No error (D)",
    options: ["A. Each of the students", "B. have submitted", "C. the assignment on time", "D. No error"],
    answer: "B"
  },
  {
    id: 98,
    question: "Choose the correct preposition: The clerk was accused ______ forging the documents.",
    options: ["A. of", "B. for", "C. with", "D. about"],
    answer: "A"
  },
  {
    id: 99,
    question: `Arrange the parts to form a meaningful sentence:
      P: the importance of
      Q: regular exercise
      R: doctors often emphasise
      S: for a healthy life`,
    options: ["A. PQRS", "B. RQPS", "C. QRPS", "D. RPQS"],
    answer: "D"
  },
  {
    id: 100,
    question: "Read the passage and answer the question: \"Although renewable energy has become far cheaper over the past decade, its adoption is slowed by the intermittent nature of sources such as solar and wind, which makes reliable energy storage essential.\" According to the passage, what is the main obstacle to wider adoption of renewable energy?",
    options: [
      "A. Its high cost compared with fossil fuels",
      "B. A lack of public interest",
      "C. The intermittent supply from sources like solar and wind, which requires storage",
      "D. Government restrictions on new power plants"
    ],
    answer: "C"
  }
];

export default pgcetmcaGeneralEnglish;
